import { LanguageDefinition } from "@rinami/cc7-ng";

/**
 * Languages supported by the app. `code` is also the translation file name (`public/assets/i18n/<code>.json`).
 * To add a language, add an entry here, add its JSON file, and add its `labelKey` to every language JSON.
 */
export const APP_LANGUAGES: LanguageDefinition[] = [
  { code: "en", labelKey: "languageSelection.option.english" },
  { code: "es", labelKey: "languageSelection.option.spanish" },
];
